import React, {Fragment} from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'
import breakpoint, {map} from 'components/breakpoint'
import {isApple} from 'utils/deviceUtils'
import Title from 'components/Title'
import {LOGIN_CASES} from 'const'

const getFontSize = props => map(props.theme.logisterSection.title.fontSize, val => val && `font-size: ${val};`)
const getLineHeight = props => map(props.theme.logisterSection.title.lineHeight, val => val && `line-height: ${val};`)
const getMargin = props => props.theme.registerPage.titleMargin.default
const getPortraitMargin = props => props.theme.registerPage.titleMargin.portrait
const getMobileFontSizeByGame = ({loginCase}) => loginCase === LOGIN_CASES.BLICK.SKI_TROPHY_GAME && 'font-size: 28px;'

const StyledTitle = styled(Title)`
  ${getFontSize};
  ${getLineHeight};

  margin: ${getMargin};

  ${breakpoint('portrait')`
    margin: ${getPortraitMargin};
  `};
`

const getTextChangeBreakpoint = props => props.theme.logisterSection.title.textChangeBreakpoint

const LogisterPageTitleShort = styled(StyledTitle)`
  display: block;
  max-width: 460px;
  ${getMobileFontSizeByGame}

  ${props => breakpoint(getTextChangeBreakpoint(props))`
    display: none;
  `};
`

const LogisterPageTitleLong = styled(StyledTitle)`
  display: none;

  ${props => breakpoint(getTextChangeBreakpoint(props))`
    display: block;
    max-width: 460px;
  `};
`

const getTitlePairByCase = (loginCase, gameTitle) => {
  if (gameTitle) {
    const shortTitle = gameTitle.short || 'logister-header'
    const longTitle = gameTitle.long || 'logister-header-long'
    return [shortTitle, longTitle]
  }

  const isSummitsCase = loginCase === LOGIN_CASES.BLICK.SUMMITS
  const isWinterAwardsCase = loginCase === LOGIN_CASES.BLICK.WINTER_AWARDS
  const isBlickJackpotCase = loginCase === LOGIN_CASES.BLICK.JACKPOT_2023_GAME

  const isTrophyCase = [
    LOGIN_CASES.BLICK.SKI_TROPHY_GAME,
    LOGIN_CASES.BLICK.MEDAILLEN_TROPHY_GAME,
    LOGIN_CASES.BLICK.ICEHOCKEY_GAME,
    LOGIN_CASES.BLICK.EM_2022_GAME,
    LOGIN_CASES.BLICK.ESAF_2022_GAME,
    LOGIN_CASES.BLICK.SKI_TROPHY_2223_GAME,
    LOGIN_CASES.BLICK.UNIHOCKEY_WM_2022_GAME,
    LOGIN_CASES.BLICK.SOCCER_WM_2022_GAME,
    LOGIN_CASES.BLICK.EISHOCKEY_WM_2023_GAME,
  ].includes(loginCase)

  if (isSummitsCase) {
    return ['logister-header-summits', 'logister-header-long-summits']
  }
  if (isWinterAwardsCase) {
    return ['logister-header-winter-awards', 'logister-header-winter-awards']
  }
  if (isTrophyCase) {
    return ['logister-header-trophy-case', 'logister-header-trophy-case']
  }
  if (isBlickJackpotCase) {
    return ['logister-header-jackpot-2023-case', 'logister-header-jackpot-2023-case']
  }
  return ['logister-header', 'logister-header-long']
}

const LogisterPageTitle = ({loginCase, t, webauthn, type, gameTitle}) => {
  const [shortTitle, longTitle] = getTitlePairByCase(loginCase, gameTitle)
  const pageTitle = isApple() ? `logister-header-webauthn.apple.${type}` : `logister-header-webauthn.${type}`
  if (webauthn) {
    return (
      <Fragment>
        <LogisterPageTitleShort loginCase={loginCase}>{t(pageTitle)}</LogisterPageTitleShort>
        <LogisterPageTitleLong>{t(pageTitle)}</LogisterPageTitleLong>
      </Fragment>
    )
  }
  return (
    <Fragment>
      <LogisterPageTitleShort loginCase={loginCase}>{t(shortTitle)}</LogisterPageTitleShort>
      <LogisterPageTitleLong>{t(longTitle)}</LogisterPageTitleLong>
    </Fragment>
  )
}

export default translate()(LogisterPageTitle)
